import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_REQUESTFORQUOTATION } from "../../../../utils/constants";
import { RFQInterface } from "../../../../models/ProcurementModule/RequestForQuotation";
import RFQService from "../../../../services/procurementService/RFQService";

interface DeleteRFQ {
  previousRFQ: RFQInterface[];
  deletedPR: RFQInterface | undefined;
}

const useDeleteRFQ = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string, DeleteRFQ>({
    mutationFn: RFQService.Remove,

    onMutate: (dataId: string) => {
      const previousRFQ =
        queryClient.getQueryData<RFQInterface[]>([
          CACHE_KEY_REQUESTFORQUOTATION,
          page,
          pageSize,
        ]) || [];

      queryClient.setQueryData<RFQInterface[]>(
        [CACHE_KEY_REQUESTFORQUOTATION, page, pageSize],
        previousRFQ.filter((data) => data.id !== dataId)
      );

      return {
        previousRFQ,
        deletedPR: previousRFQ.find((data) => data.id === dataId),
      };
    },

    onError: (error, dataId, context) => {
      if (!context) return;

      queryClient.setQueryData<RFQInterface[]>(
        [CACHE_KEY_REQUESTFORQUOTATION, page, pageSize],
        context.previousRFQ
      );
    },

    onSuccess: () => {
      // Optionally, you could perform additional actions on success
      // For example, invalidating queries or updating other parts of the state
    },
  });
};

export default useDeleteRFQ;
